import React, { useEffect, useState } from 'react';
import styles from './CarouselNode.module.scss';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import chatbot from '../image-node/chatbot-drupal 1.png';
import CarouselModal from './carousel-modal/CarouselModal';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const CardImage = ({ file, url, uploadOrUrl }) => {
  const [previewUrl, setPreviewUrl] = useState('');

  useEffect(() => {
    if (file?.fileContent) {
      setPreviewUrl(`data:image/png;base64,${file.fileContent}`);
    } else if (url !== '' && file instanceof File) {
      const objectUrl = URL.createObjectURL(file);
      setPreviewUrl(objectUrl);

      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreviewUrl(url);
    }
  }, [file, url, uploadOrUrl]);

  return previewUrl ? (
    <img src={previewUrl || ''} alt="" />
  ) : (
    <SvgWithBranding type="node-image" color="#787878" />
  );
};

const CarouselNode = ({ id, selected, ...props }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(node?.is_Error || false);

  const carouselData = node?.carousel;
  const cards = carouselData?.details || [];

  const isAnyCardTitleEmpty = node?.carousel?.details?.some(
    (item) => item.cardTitle.trim() === ''
  );
  const isAnyCardFile = node?.carousel?.details?.some(
    (item) => item.file === ''
  );
  const isAnyBlobUrlEmpty = node?.carousel?.details?.some(
    (item) => item.blobUrl.trim() === ''
  );
  useEffect(() => {
    if (node?.carousel) {
      if (isAnyCardTitleEmpty || (isAnyBlobUrlEmpty && isAnyCardFile)) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.carousel]);

  return (
    <>
      <NodeContainer
        name={node?.title ?? 'Carousel Block'}
        id={id}
        backgroundColor={node?.color}
        selected={selected}
        onClick={() => setIsModalOpen(true)}
        node={node}
        isError={isError}
      >
        <Handle
          type="target"
          position={Position.Left}
          className="custom-handle"
        />
        <div className={styles['cards-container']}>
          {cards.length > 0 ? (
            cards.map((card, index) => (
              <div key={index} className={styles.document}>
                <CardImage
                  file={card.file}
                  url={card.blobUrl}
                  uploadOrUrl={card.uploadOrUrl}
                />
                <div className={styles.text}>
                  <div className={styles['card-info']}>
                    <p>{card.cardTitle || 'No title'}</p>

                    <p> {card.cardDescription || 'No description'}</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className={styles.document}>
              <SvgWithBranding type="node-image" color="#787878" />
              <div className={styles.text}>
                <div className={styles['card-info']}>
                  <p>Card Title</p>
                  <p className={styles.placeholder}>Upload</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <Handle
          type="source"
          position={Position.Right}
          className="custom-handle"
        />
      </NodeContainer>
      <CarouselModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Carousel"
        id={id}
        isError={isError}
      />
    </>
  );
};

export default CarouselNode;
